export default "__VITE_ASSET__ca470890__"